var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "layerWrapper pop_event_01",
      staticStyle: { display: "block" },
      on: { click: _vm.close }
    },
    [
      _c(
        "div",
        {
          staticClass: "cbox layerBox popWidM",
          staticStyle: { opacity: "10", position: "relative", top: "30%" }
        },
        [
          _c("div", { staticClass: "cart-popup__dialog" }, [
            _c("div", { staticClass: "cart-popup__content height-auto" }, [
              _c(
                "div",
                {
                  staticClass: "cart-popup__item-info",
                  staticStyle: { padding: "0" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "os_noticeRes",
                      attrs: { "data-btn-close": "closeLayer" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "padS txtC",
                          staticStyle: {
                            "background-color": "#50b4b8",
                            color: "#fff"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "padSM padBM",
                              staticStyle: {
                                border: "2px solid #fff",
                                "border-radius": "18px"
                              }
                            },
                            [
                              _vm._m(0),
                              _vm._v(" "),
                              _vm.type == "1"
                                ? [
                                    _vm._m(1),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "marTSM fntH6 fntL" },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            "본 이벤트는 " +
                                              _vm._s(_vm.message) +
                                              " 부터"
                                          ),
                                          _c("br"),
                                          _vm._v("신청 가능합니다.")
                                        ])
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.type == "2"
                                ? [_vm._m(2), _vm._v(" "), _vm._m(3)]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.type == "3"
                                ? [_vm._m(4), _vm._v(" "), _vm._m(5)]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.type == "4"
                                ? [
                                    _vm._m(6),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "marTSM fntH6 fntL" },
                                      [
                                        _c("strong", [
                                          _vm._v(_vm._s(_vm.message))
                                        ])
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticStyle: {
          "max-width": "129px",
          "min-width": "60px",
          width: "35%"
        },
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/_noticeImg/2022/01/0107_ev_skin_nutrition/logo_03.png",
          alt: "Artistry Skin Nutrition(로고)"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "marTM" }, [
      _c("img", {
        staticClass: "icoXS",
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/_noticeImg/2022/01/0107_ev_skin_nutrition/ico_01.png",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "marTM" }, [
      _c("img", {
        staticClass: "icoXS",
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/_noticeImg/2022/01/0107_ev_skin_nutrition/ico_02.png",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "marTSM fntH6 fntL" }, [
      _c("strong", [_vm._v("이벤트 신청 완료 되었습니다.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "marTM" }, [
      _c("img", {
        staticClass: "icoXS",
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/_noticeImg/2022/01/0107_ev_skin_nutrition/ico_03.png",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "marTSM fntH6 fntL" }, [
      _c("strong", [
        _vm._v("본 이벤트는 종료되어 "),
        _c("br"),
        _vm._v("신청하실 수 없습니다.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "marTM" }, [
      _c("img", {
        staticClass: "icoXS",
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/_noticeImg/2022/01/0107_ev_skin_nutrition/ico_04.png",
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c361a28", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c361a28","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/relayevent/component/popupMessage.vue
// module id = null
// module chunks = 